<app-offcanvas-base [returnUrl]="returnUrl()">
  <ng-container title>
    <app-offcanvas-header-btn [title]="title()"></app-offcanvas-header-btn>
  </ng-container>
  <ng-container body>
    @if (selectedRule()) {
      <div class="cards-dropdown-offset-wrapper topup-edit">
        <div class="row align-items-center mb-4">
          <div class="col-auto pe-1">
            <app-avatar
              [firstName]="selectedRule()?.employee?.first_name"
              [lastName]="selectedRule()?.employee?.last_name"
              [size]="'md'"></app-avatar>
          </div>
          <div class="col-auto">
            @if (selectedRule()?.card?.type === CardType.Personal) {
              <div class="title">
                {{ selectedRule()?.employee?.first_name }} {{ selectedRule()?.employee?.last_name }}
              </div>
              <div class="text-sm">
                <div class="badge text-body bg-gray">
                  {{ selectedRule()?.card?.masked_number | slice: 8 : 16 | emptyIndicator }}
                </div>
                /
                <div class="badge text-info bg-info">Employee</div>
              </div>
            } @else {
              <div class="title">{{ selectedRule()?.card?.name }}</div>
              <div class="text-sm">
                <div class="badge text-body bg-gray">
                  {{ selectedRule()?.card?.masked_number | slice: 8 : 16 | emptyIndicator }}
                </div>
                /
                <div class="badge text-body bg-gray">
                  {{ selectedRule()?.employee?.first_name }} {{ selectedRule()?.employee?.last_name }}
                </div>
                /
                <div class="badge text-success bg-success">Subscription</div>
              </div>
            }
          </div>
          <div class="col-auto ms-auto">
            @if (selectedRule()?.is_removed) {
              <app-status-badge
                value="Stopped"
                [department]="statusBadgeDepartments.TOPUPS"></app-status-badge>
            } @else if (selectedRule()?.schedule_status) {
              <app-status-badge
                [value]="selectedRule()?.schedule_status ?? ''"
                [department]="statusBadgeDepartments.TOPUPS"></app-status-badge>
            }
          </div>
        </div>
      </div>
    } @else {
      <div class="cards-dropdown-offset-wrapper topup">
        <p class="form-label">Which card would you like to top up?</p>
        @if (cardTopupsService.isLoading()) {
          <p class="text-muted">Loading cards...</p>
        } @else {
          <div class="mb-3">
            <ng-select
              id="typeahead"
              class="cards-dropdown"
              [(ngModel)]="selectedCard"
              [items]="cardsList()"
              [searchable]="true"
              [searchFn]="customSearchFn"
              [clearable]="false"
              notFoundText="No cards available"
              placeholder="Search card name or type">
              <ng-template
                ng-option-tmp
                let-item="item">
                <app-ng-select-card-dropdown-options
                  [item]="item"
                  [isRecurring]="isRecurring()"></app-ng-select-card-dropdown-options>
              </ng-template>

              <ng-template
                ng-label-tmp
                let-item="item">
                <app-ng-select-card-label-options
                  [item]="item"
                  [isRecurring]="isRecurring()"></app-ng-select-card-label-options>
              </ng-template>
            </ng-select>
          </div>
          @if (isRecurring() && selectedCard?.recurring_rule_id) {
            <div
              class="alert alert-warning mb-3"
              role="alert">
              <div class="row align-items-center">
                <div class="col-auto pe-1">
                  <i class="iconoir-warning-circle"></i>
                </div>
                <div class="col small">
                  This card already has a recurring top-up rule.<br />
                  To edit the existing recurring top-up rule
                  <button
                    id="btnEditRule"
                    (click)="editRule(selectedCard?.recurring_rule_id)"
                    class="btn-reset btn-link d-inline fw-medium text-warning w-auto">
                    click here
                  </button>
                </div>
              </div>
            </div>
          }
        }
      </div>
    }
    <app-card-topup-form
      (existingRule)="handleRuleData($event)"
      [selectedCard]="selectedCard"
      class="offcanvas-body-inner" />
  </ng-container>
</app-offcanvas-base>
